export const BROADCAST_CHANNEL_NAME = 'broadcast-channel';
